import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import Button from '../Button/Button';
import withClickOutside from '../withClickOutside/withClickOutside';

class Panel extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false, fakeValues: [] };
        this.clickOutsideRef = React.createRef();
    }

    componentDidMount() {
        const { defaultIsOpen } = this.props;
        if (defaultIsOpen) {
            this.open();
        }
    }

    handleClickOutside = () => {
        this.close();
    };

    setFakeValues = () => {
        const { numberOfPlaceholderSections } = this.props;
        this.setState({
            fakeValues: Array(numberOfPlaceholderSections)
                .fill(null)
                .map((_, containerIndex) =>
                    Array(2)
                        .fill(null)
                        .map((__, lineIndex) => ({
                            width: Math.floor(Math.random() * (10 - 90) + 90),
                            containerIndex,
                            lineIndex,
                        }))
                ),
        });
    };

    open = () => {
        this.setFakeValues();
        this.setState({ open: true });
    };

    close = () => {
        const { open } = this.state;
        if (open) {
            const { closeCb } = this.props;
            this.setState({ open: false }, () => {
                if (closeCb) {
                    closeCb();
                }
            });
        }
    };

    toggle = () => {
        const { open } = this.state;
        if (open) {
            this.close();
        } else {
            this.open();
        }
    };

    getPlaceholderSections = () => {
        const { fakeValues } = this.state;
        return (
            <div className="panel__body__fake-content">
                {fakeValues.map((section) => (
                    <div className="panel__body__fake-content__section" key={`section-${section[0].containerIndex}`}>
                        {section.map(({ width, containerIndex, lineIndex }) => (
                            <div
                                className="panel__fake-line"
                                key={`section-${containerIndex}-${lineIndex}`}
                                style={{ width: `${width}%` }}
                            />
                        ))}
                    </div>
                ))}
            </div>
        );
    };

    // eslint-disable-next-line class-methods-use-this
    getPlaceholderHeader = () => <span className="panel__header__fake-action" />;

    render() {
        const { open } = this.state;
        const { position, header, disableCloseOutside, loading, testId, children, ...rest } = this.props;
        return (
            <AnimatePresence>
                {open && (
                    <motion.div
                        ref={this.clickOutsideRef}
                        data-testid={testId}
                        className={cl('panel', `panel--${position}`)}
                        initial={{ right: -300 }}
                        animate={{ right: 0 }}
                        exit={{ right: -400 }}
                        transition={{
                            type: 'spring',
                            stiffness: 800,
                            damping: 35,
                        }}
                        {...rest}
                    >
                        <div className="panel__header">
                            {loading
                                ? this.getPlaceholderHeader()
                                : header && <div className="panel__header__content">{header}</div>}

                            <div className="panel__header__action">
                                <Button
                                    className={cl('panel__header__action__btn')}
                                    icon="close"
                                    type="link-flex"
                                    onClick={this.close}
                                    testId={`${testId}-close-button`}
                                />
                            </div>
                        </div>
                        <div className="panel__body">{loading ? this.getPlaceholderSections() : children}</div>
                    </motion.div>
                )}
            </AnimatePresence>
        );
    }
}

Panel.defaultProps = {
    position: 'right',
    defaultIsOpen: false,
    closeCb: null,
    header: null,
    disableCloseOutside: false,
    testId: 'panel',
    loading: false,
    numberOfPlaceholderSections: 6,
};

Panel.propTypes = {
    closeCb: PropTypes.func,
    testId: PropTypes.string,
    defaultIsOpen: PropTypes.bool,
    disableCloseOutside: PropTypes.bool,
    children: PropTypes.node.isRequired,
    position: PropTypes.oneOf(['right', 'left']),
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    loading: PropTypes.bool,
    numberOfPlaceholderSections: PropTypes.number,
};

export default withClickOutside(Panel, '.ignore-click-outside-panel');
